import React, { Component } from 'react'
import { Element } from 'react-scroll'
import _ from 'lodash'
import S from 'shorti'
import config from '../../../../config/public'
import cn from 'classnames'
import { Carousel, Modal } from 'react-bootstrap'
const { NODE_ENV, BUILDING } = process.env
if (NODE_ENV === 'development' || BUILDING === 'true')
  require('./assets/styles/main.scss')
class Template extends Component {
  selectMenu = (e, name) => {
    e.preventDefault()
    const coord = this[name].getBoundingClientRect()
    window.scrollTo(0, coord.top)
  }
  getAsset = (asset) => {
    let image
    image = (NODE_ENV === 'development' || BUILDING === 'true') ?
      require('./assets/images/' + asset) :
      '/images/' + asset
    return image
  }
  getListingCityStateZip() {
    const data = this.props.data
    const website = data.website || this.props.website
    return website.listing && website.listing.property ? `${website.listing.property.address.city}, ${website.listing.property.address.state} ${website.listing.property.address.postal_code}` : `${data.attributes.listing_city} ${data.attributes.listing_state} ${data.attributes.listing_postal_code}`
  }
  getCoverImage() {
    const data = this.props.data
    const website = data.website || this.props.website
    if (website.listing && website.attributes.cover_image)
      return website.attributes.cover_image
    // Return default cover image
    if (website.listing && !website.attributes.cover_image)
      return website.listing.cover_image_url
    if (!website.listing && !website.attributes.cover_image)
      return this.getAsset('home.png')
  }
  getMasterBedroomImage() {
    const data = this.props.data
    const website = data.website || this.props.website
    if (website.listing && website.attributes.master_bedroom_image)
      return website.attributes.master_bedroom_image
    if (website.listing && !website.attributes.master_bedroom_image)
      return this.getAsset('img02.jpg')
    if (!website.listing)
      return this.getAsset('img02.jpg')
  }
  getDetailImage1() {
    const data = this.props.data
    const website = data.website || this.props.website
    if (website.listing && website.attributes.detail_image_1)
      return website.attributes.detail_image_1
    if (website.listing && !website.attributes.detail_image_1)
      return this.getAsset('img03.jpg')
    if (!website.listing)
      return this.getAsset('img03.jpg')
  }
  getDetailImage2() {
    const data = this.props.data
    const website = data.website || this.props.website
    if (website.listing && website.attributes.detail_image_2)
      return website.attributes.detail_image_2
    if (website.listing && !website.attributes.detail_image_2)
      return this.getAsset('img04.png')
    if (!website.listing)
      return this.getAsset('img04.png')
  }
  getAmenitiesImage() {
    const data = this.props.data
    const website = data.website || this.props.website
    if (website.listing && website.attributes.amenities_image)
      return website.attributes.amenities_image
    if (website.listing && !website.attributes.amenities_image)
      return this.getAsset('img06.png')
    if (!website.listing)
      return this.getAsset('img06.png') 
  }
  metersToFeet(meters) {
    return Math.round(meters * '10.7639')
  }
  getAmenitiesList() {
    const data = this.props.data
    const website = data.website || this.props.website
    const listing = website.listing
    if (!listing)
      return (
      <div>
        <ul className="list">
          <li>Attached Parking</li>
          <li>On-site Parking</li>
          <li>Double Entry Bathroom</li>
          <li>2 Garages</li>
        </ul>
        <ul className="list">
          <li>Central Heating</li>
          <li>Large Patio</li>
          <li>Hardwood Floors</li>
          <li>Marble Countertops</li>
        </ul>
        <ul className="list">
          <li>Rooftop Patio</li>
          <li>20’ vaulted cielings</li>
          <li>Floor to cieling windows</li>
          <li>Pool</li>
        </ul>
      </div>
    )
    const interior_features = listing.property.interior_features
    const exterior_features = listing.property.exterior_features
    const amenities = [...interior_features,...exterior_features]
    let list_style = {
      ...S('pull-left display-inline m-10'),
      listStyle: 'none'
    }
    return (
      <div>
        <ul>
          {
            amenities.map(amenity => {
              return (
                <li key={ amenity } style={ list_style }>
                  { amenity }
                </li>
              )
            })
          }
        </ul>
      </div>
    )
  }
  getGoogleMap() {
    const data = this.props.data
    const website = data.website || this.props.website
    if (!website.listing)
      return
    const listing_title = `${website.listing.property.address.street_number} ${website.listing.property.address.street_name}`
    const address = listing_title + ' ' + this.getListingCityStateZip()
    return(
      <iframe
        width="100%"
        height="450"
        frameBorder="0"
        style={{ border: 0, pointerEvents: 'none' }}
        src={`https://www.google.com/maps/embed/v1/place?key=${config.google.api_key}&q=${address}`}
        allowFullScreen>
      </iframe>
    )
  }
  getGallery() {
    const data = this.props.data
    const website = data.website || this.props.website
    const listing = website.listing
    let modal_gallery_area
    if (website.listing) {
      const gallery_image_urls = listing.gallery_image_urls
      modal_gallery_area = (
        <Carousel>
          {
            gallery_image_urls.map((gallery_image_url, i) => {
              return (
                <Carousel.Item key={ 'gallery-image-' + gallery_image_url[0] + i }>
                  <div style={ S('w-100p h-500 pull-left text-center bg-efefef bg-cover bg-center bg-url(' + gallery_image_url + ')') }/>
                </Carousel.Item>
              )
            })
          }
        </Carousel>
      )
      return (
        <Modal bsSize="large" show={ data.show_modal_gallery } onHide={ this.props.hideModalGallery }>
          <div style={ S('relative') }>
            <div style={ S('absolute r-0 t-60n font-60 z-1000 fw-100') } className="close" onClick={ this.props.hideModal }>&times;</div>
          </div>
          { modal_gallery_area }
        </Modal>
      )
    }
  }
  render() {
    const data = this.props.data
    if (!data)
      return <div></div>
    const website = data.website || this.props.website
    let brand = data.brand
    if (website && website.brand && website.brand.id)
      brand = website.brand
    if (!website)
      return <div className="loading"></div>
    const { attributes, user } = website
    if (!website.user && data.user)
      website.user = data.user
    let listing_title = attributes.listing_title
    if (website.listing && website.listing.property)
      listing_title = `${website.listing.property.address.street_number} ${website.listing.property.address.street_name}`
    return (
      <div id="wrapper" className="template__clean">
        <div className="header-area">
          <header id="header">
            <div className="logo">
              <a href="#">
                <span className="image-holder">
                  <Element
                    name="step-9"
                    className={ cn({ 'dashed-border': data.step === 9 }) }
                    onClick={ this.props.goToStep.bind(this, 9) }
                  >
                    <img src={ attributes.brokerage_logo ? attributes.brokerage_logo : this.getAsset('brokerage.png') } alt="Sam Sawyer | Studio By Rechat" />
                  </Element>
                </span>
              </a>
            </div>
            <a href="#" className="nav-opener"><span></span></a>
            <nav id="nav">
              <ul className="navbar" style={ S('t-10') }>
                <li><a href="#listing-info-section">listing info</a></li>
                <li><a href="#details-section">details</a></li>
                <li><a href="#about-section">about { website.user ? website.user.first_name : '' }</a></li>
                <li><a href="#contact-section">contact</a></li>
              </ul>
              <div className="btn-holder">
                <a onClick={ this.props.showModalGallery.bind(this) } href="#" className="btn btn-dark"><span className="icon-arrow-alt"></span> { website.listing ? website.listing.gallery_image_urls.length : 0 } Photos</a>
                <a target="_blank" href={`${brand ? brand.base_url : config.rechat_url}/signup?inviting_user=${user.id}`} className="btn btn-primary"><span className="image-holder"><img src={ website.user && website.user.profile_image_url ? website.user.profile_image_url : this.getAsset('img08.png') } alt="agent"/></span>learn more</a>
              </div>
            </nav>
          </header>
          <Element
            name="step-2"
            className={ cn({ 'dashed-border': data.step === 2 }) }
            onClick={ this.props.goToStep.bind(this, 2) }
          >
            <div className="banner">
              <div className="banner-wrap win-height">
                <div className="banner-slide">
                  <div className="bg-stretch" style={{ backgroundImage: `url(${this.getCoverImage()})` }}></div>
                  <div className="banner-caption">
                    <h1 className="banner-title">{ listing_title }</h1>
                    { 
                      website && website.listing && website.listing.open_houses &&
                      <div className="schedule hidden-xs hidden-sm">
                        <strong className="title">Open House!</strong>
                        <em className="date"><time dateTime="2017-01-07 14:00">Sat Jan 7, 2PM-4PM</time></em>
                        <em className="date"><time dateTime="2017-01-08 14:00">Sat Jan 8, 2PM-4PM</time></em>
                      </div>
                    }
                    <div className="btn-holder">
                      <a href="#" className="btn btn-primary"><span className="image-holder"><img src={ this.getAsset('img08.png') } alt="agent"/></span>learn more</a>

                      <a href="#" className="btn btn-dark"><span className="icon-arrow-alt"></span> 30 Photos</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Element>
          <a href="#main" className="next hidden-xs"><span className="icon-arrow-bottom"></span></a>
        </div>
        <main id="main" role="main">
          { 
            website && website.listing && website.listing.open_houses &&
            <div className="schedule visible-xs">
              <strong className="title">Open House!</strong>
              <em className="date"><time dateTime="2017-01-07 14:00">Sat Jan 7, 2PM-4PM</time></em>
              <em className="date"><time dateTime="2017-01-08 14:00">Sat Jan 8, 2PM-4PM</time></em>
            </div>
          }
          <div className="info" id="listing-info-section">
            <div className="container">
              <Element
                name="step-3"
                className={ cn({ 'dashed-border': data.step === 3 }) }
                onClick={ this.props.goToStep.bind(this, 3) }
              >
                <h2>{ attributes.tagline }</h2>
              </Element>
              <p>{ website.listing && website.listing.property ? website.listing.property.description : attributes.description }</p>
            </div>
          </div>
          <Element
            name="step-4"
            className={ cn({ 'dashed-border': data.step === 4 }) }
            onClick={ this.props.goToStep.bind(this, 4) }
          >
            <div className="image-stretch">
              <div className="bg-stretch" style={{ backgroundImage: `url(${this.getMasterBedroomImage()})` }}></div>
              <div className="image-caption">
                <em>One of kind</em>
                <strong className="title">Master Bedroom</strong>
                <a onClick={ this.props.showModalGallery.bind(this) } href="#" className="btn btn-inverse hidden-xs"><span className="icon-arrow-alt"></span> { website.listing ? website.listing.gallery_image_urls.length : 0 } Photos</a>
              </div>
            </div>
          </Element>
          <div className="post" id="details-section">
            <div className="container">
              <h2>It's all in the <mark>details</mark>.</h2>
              <Element
                name="step-5"
                className={ cn({ 'dashed-border': data.step === 5 }) }
                onClick={ this.props.goToStep.bind(this, 5) }
              >
                <div className="post-block">
                  <div className="image-holder">
                    <img src={ this.getDetailImage1() } alt="agent"/>
                  </div>
                  <div className="post-detail">
                    <div className="holder">
                      <h3 className="post-title">${ website.listing ? website.listing.price : attributes.listing_price }</h3>
                      <div className="text-holder">
                        <a href="#" className="btn btn-secondary btn-xs">{ website.listing ? website.listing.status : attributes.listing_status }</a>
                        <address>{ listing_title } <span className="font"><br/><em>{ this.getListingCityStateZip() }</em><span className="seperator hidden-xs">|</span><br className="visible-xs"/><em>MLS#: { website.listing ? website.listing.mls_number : attributes.listing_mls_number }</em></span></address>
                      </div>
                    </div>
                  </div>
                </div>
              </Element>
            </div>
          </div>
          <div className="post post-light-gray">
            <div className="container">
              <ul className="post-list">
                <li>
                  <div className="column">
                    <strong className="counter">{ website.listing ? website.listing.property.bedroom_count : attributes.listing_bedroom_count }</strong>
                    <span>Beds</span>
                  </div>
                </li>
                <li>
                  <div className="column">
                    <strong className="counter">{ website.listing ? website.listing.property.bathroom_count : attributes.listing_bathroom_count }</strong>
                    <span>Baths</span>
                  </div>
                </li>
                <li>
                  <div className="column">
                    <strong className="counter">{ website.listing ? this.metersToFeet(website.listing.property.square_meters) : attributes.listing_square_feet }</strong>
                    <span>Sqft- approximate</span>
                  </div>
                </li>
                <li>
                  <div className="column">
                    <strong className="counter">{ website.listing ? this.metersToFeet(website.listing.property.lot_square_meters) : attributes.listing_lot_square_meters }</strong>
                    <span>Lot size</span>
                  </div>
                </li>
                {
                  website.listing && website.listing.property.year_built &&
                  <li>
                    <div className="column">
                      <strong className="counter">{ website.listing ? website.listing.property.year_built : attributes.listing_year_built }</strong>
                      <span>Built in</span>
                    </div>
                  </li>
                }
              </ul>
            </div>
          </div>
          <div className="post post-description">
            <div className="container">
              <Element
                name="step-6"
                className={ cn('image-holder', { 'dashed-border': data.step === 6 }) } style={ S(`w-300 h-300 br-1000 bg-cover bg-center bg-url(${this.getDetailImage2()})`) }
                onClick={ this.props.goToStep.bind(this, 6) }
              >
              </Element>
              <div className="post-block">
                <h3>Key Details</h3>
                <ul className="detail-list">
                  <li><em>Neighborhood</em><span>{ website.listing ? website.listing.property.subdivision_name : 'University Park' }</span></li>
                  <li><em>Property Type</em><span>{ website.listing ? website.listing.property.property_subtype : 'Single-Family Homes' }</span></li>
                  <li><em>County</em><span>{ website.listing ? website.listing.property.address.county_or_parish : 'Cook County' }</span></li>
                </ul>
              </div>
            </div>
          </div>
          <Element
            name="step-7"
            className={ cn({ 'dashed-border': data.step === 7 }) }
            onClick={ this.props.goToStep.bind(this, 7) }
          >
            <div className="post post-dark-gray" style={ S(`bg-cover bg-center bg-url(${this.getAmenitiesImage()}) relative`) }>
              <div className="overlay" style={ S('l-0 absolute h-100p w-100p bg-000 op-.5 z-1') }></div>
              <div style={ S('l-0 absolute h-100p w-100p z-2 p-100') }>
                <div className="post-holder">
                  <h3>Amenities</h3>
                  {
                    attributes.pdf &&
                    <a target="_blank" href={ attributes.pdf } className="btn btn-primary">DOWNLOAD PDF</a>
                  }
                  <div className="post-wrap">
                    { this.getAmenitiesList() }
                  </div>
                </div>
              </div>
            </div>
          </Element>
          <div className="map">
            <div className="container">
              <h2>Want to see this home? <br className="visible-xs"/>I can help you.</h2>
              <a target="_blank" href={`${brand ? brand.base_url : config.rechat_url}/signup?inviting_user=${user.id}`} className="btn btn-outline btn-lg"><span className="icon-chat"></span> LEARN MORE</a>
            </div>
            <div className="map-holder">
              <div className="bg-stretch" style={{ backgroundImage: `url(${this.getAsset('img09.jpg')}` }}></div>
              <div className="map-detail">
                <strong>Neighborhood for { listing_title }</strong>
              </div>
              { this.getGoogleMap() }
            </div>
          </div>
          <div className="testimonial" style={ S('bg-F7F7F7 pt-40') }>
            <div className="image-holder">
              <Element
                name="step-8"
                className={ cn({ 'dashed-border': data.step === 8 }) }
                onClick={ this.props.goToStep.bind(this, 8) }
              >
                <div className="bg-stretch" style={{ backgroundImage: `url(${ attributes.personal_image ? attributes.personal_image : this.getAsset('nora.png')})` }}></div>
                <div className="clearfix"></div>
              </Element>
            </div>
            <div className="testimonial-holder" id="about-section">
              <div className="testimonial-wrap">
                <h2>{ website.user ? website.user.display_name : '' }</h2>
                <Element
                    name="step-10"
                    className={ cn({ 'dashed-border': data.step === 9 }) }
                    onClick={ this.props.goToStep.bind(this, 9) }
                  >
                  <em className="company"> { attributes.brokerage_title }</em>
                </Element>
                <dl>
                  <dt>&nbsp;</dt>
                  <dd>E: <a href={ `mailto:${website.user.email}` }>{ website.user ? website.user.email : '' }</a></dd>
                  <dt>&nbsp;</dt>
                  <dd>M: <a href="tel:619-300-8675">{ website.user ? website.user.phone_number : '' }</a></dd>
                </dl>
                {
                 attributes.website &&
                 <a href={ attributes.website } className="more"><span className="icon-arrow-right"></span> <span>check out my website!</span></a>
                }
              </div>
            </div>
          </div>
        </main>
        <footer id="footer">
          <aside className="footer-navigation" id="contact-section">
            <div className="container">
              <div className="footer-holder">
                <div className="col-sm-6">
                  <img src={ attributes.brokerage_logo ? attributes.brokerage_logo : this.getAsset('brokerage.png') } alt="Studio By Rachat" className="img-responsive" style={ S('maxw-300 center-block') }/>
                </div>
                <div className="col-sm-6">
                  <Element
                    name="step-11"
                    className={ cn({ 'dashed-border': data.step === 11 }) }
                    onClick={ this.props.goToStep.bind(this, 11) }
                  >
                    <ul className="social-networks">
                      { 
                        attributes.facebook_url &&
                        <li><a href={ attributes.facebook_url }><span className="icon-facebook"></span></a></li>
                      }
                      {
                        attributes.twitter_url &&
                        <li><a href={ attributes.twitter_url }><span className="icon-twitter"></span></a></li>
                      }
                      {
                        attributes.instagram_url &&
                        <li><a href={ attributes.instagram_url }><span className="icon-instagram"></span></a></li>
                      }
                      {
                        attributes.web_url &&
                        <li><a href={ attributes.web_url }><span className="icon-web"></span></a></li>
                      }
                    </ul>
                    <div className="clearfix"></div>
                  </Element>
                  <div className="store text-center">
                    <strong className="title">Join me on the app</strong>
                    <Element
                      name="step-12"
                      className={ cn({ 'dashed-border': data.step === 12 }) }
                      onClick={ this.props.goToStep.bind(this, 12) }
                    >
                      <ul>
                        <li style={ S('mb-15') }><a href={ attributes.apple_store }><img src={ this.getAsset('icon-apple-store.png') } alt="agent"/></a></li>
                        <li style={ S('mb-15') }><a href={ attributes.play_store }><img src={ this.getAsset('icon-play-store.png') } alt="agent"/></a></li>
                      </ul>
                    </Element>
                  </div>
                </div>
                <div className="clearfix"></div>
              </div>
            </div>
          </aside>
          <span className="credit">Powered by <a href="#">Rechat</a>&#8482;</span>
        </footer>
        { this.getGallery() }
      </div>
    )
  }
}
module.exports = Template


// WEBPACK FOOTER //
// ./src/components/Templates/clean/index.js